import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: {
    plans: [],
    features: [],
    openAd: false,
    loading: false,
    free_trail: false,
  },
};

const subscription = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    clearSubscriptionPlans: () => {
      return {
        ...initialState,
      };
    },
    updateSubscriptionPlans: (state, data) => {
      state.value.plans = data.payload.plans;
    },
    updateSubscriptionFeatures: (state, data) => {
      state.value.features = data.payload.features;
    },
    updateOpenSubscriptionAd: (state, data) => {
      state.value.openAd = data.payload.openAd;
    },
    updateLoadingSubscription: (state, data) => {
      state.value.loading = data.payload.loading;
    },
    updateFreeTrailStatus: (state, data) => {
      state.value.free_trail = data.payload.free_trail;
    },
  },
});

export const {
  updateSubscriptionPlans,
  updateSubscriptionFeatures,
  clearSubscriptionPlans,
  updateOpenSubscriptionAd,
  updateLoadingSubscription,
  updateFreeTrailStatus,
} = subscription.actions;

export default subscription.reducer;
